module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"nothingHereYet":"Nada aqui ainda."},"en":{"nothingHereYet":"Nothing here yet."}}')
  delete Component.options._Ctor
}
